const firebaseConfig = {
  apiKey: "AIzaSyD80BHl8zr5D4I_hkb-a0y0FcmGNljFJ8A",
  authDomain: "travel-plan-91822.firebaseapp.com",
  projectId: "travel-plan-91822",
  storageBucket: "travel-plan-91822.appspot.com",
  messagingSenderId: "679016625418",
  appId: "1:679016625418:web:5b0e60154108aeccca36f3"
};
  export default firebaseConfig;